import React, { useState } from 'react'
import {
  SeeAllContainer,
  SeeAllResultsUi,
  CheckboxFiltering
} from '@islandsstofa/react'
import { Link } from '@kogk/gatsby-theme-base'
import useGetCapitals from '@src/hooks/useGetCapitals'
import { CapitalCard } from '@cmp/site/Cards'
import { CAPITAL_TYPES } from '@src/utils/filtering'
import { Capital } from '@root/src/utils/resolvers'

const Results = ({
  visibleTypes = [],
  cards
}: {
  visibleTypes: string[]
  cards: Capital[]
}) => {
  const filteredCards =
    visibleTypes.length === 0
      ? cards
      : cards.filter(n =>
          n.types.map(n2 => n2.type).some(type => visibleTypes.includes(type))
        )

  if (!filteredCards) return null

  return (
    <SeeAllResultsUi
      cards={filteredCards}
      onRender={card => (
        <Link key={card.url} to={card.url}>
          <CapitalCard
            containerClass='card--tall'
            card={{
              ...card,
              tags: card.customTags
            }}
            image={card.image}
            excerptMaxLen={200}
          />
        </Link>
      )}
    />
  )
}

export default () => {
  const [visibleTypes, setVisibleTypes] = useState<string[]>([])

  const updateVisibleTypes = (t: string) => {
    if (visibleTypes.includes(t)) {
      setVisibleTypes(prev => prev.filter(type => type !== t))
    } else setVisibleTypes(prev => [t, ...prev])
  }
  const cards = useGetCapitals()

  return (
    <SeeAllContainer>
      <CheckboxFiltering
        onUpdate={updateVisibleTypes}
        items={CAPITAL_TYPES}
        label='Tegund fjármagns'
      />
      <Results cards={cards} visibleTypes={visibleTypes} />
    </SeeAllContainer>
  )
}
